export default __webpack_public_path__ + "static/media/fauna-documents-function.5e572fdf.png";